import { render, staticRenderFns } from "./AppleLoginButton.vue?vue&type=template&id=4c604589&scoped=true"
import script from "./AppleLoginButton.vue?vue&type=script&lang=js"
export * from "./AppleLoginButton.vue?vue&type=script&lang=js"
import style0 from "./AppleLoginButton.vue?vue&type=style&index=0&id=4c604589&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c604589",
  null
  
)

export default component.exports